import script from "./DetalleTorneoGestionEquiposView.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetalleTorneoGestionEquiposView.vue?vue&type=script&setup=true&lang=ts"

import "./DetalleTorneoGestionEquiposView.vue?vue&type=style&index=0&id=35e203ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35e203ea"]])

export default __exports__